import axios from 'axios';
import store from '../store';
import router from '../router';
import Toastify from 'toastify-js';

import { AUTH_LOGOUT } from '../store/actions/auth';

const api = axios.create({
  baseURL: `${process.env.VUE_APP_BASE_URL}api`,
});

api.interceptors.response.use(
  (request) => request,
  (error) => {
    const { response, config } = error;

    if (!config.url.includes('auth/admin') && response.status == 401) {
      toastSession();
      store.dispatch(AUTH_LOGOUT);
      router.push('/login');
    }

    return Promise.reject(error);
  }
);

const toastSession = () => {
  Toastify({
    text: 'Sua sessão expirou. Realize login novamente.',
    duration: 3000,
    close: true,
    gravity: 'bottom',
    position: 'left',
    stopOnFocus: true,
    className: 'info close',
  }).showToast();
};

export default api;
